<template>
  <v-app style="background-color: #e3ffe2">
    <v-overlay v-model="isLoading" id="loading">
      <v-progress-circular color="#e3ffe2" indeterminate size="64" />
    </v-overlay>
    <v-app-bar color="primary" :elevation="2" app>
      <template v-slot:append>
        <v-app-bar-nav-icon
          variant="text"
          @click.stop="
            drawer = !drawer;
            errorMsg = '';
          "
        >
        </v-app-bar-nav-icon>
      </template>
      <v-app-bar-title
        ><img
          src="./assets/logo.png"
          alt="グランハート透析クリニック インフォメーション"
          class="logo"
      /></v-app-bar-title>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      location="top"
      style="background-color: #e3ffe2"
      width="300"
    >
      <v-container style="text-align: center" v-if="loginState == false">
        <p>Admin Login</p>
        <v-text-field
          variant="outlined"
          label="USER"
          v-model="inputUser"
        ></v-text-field>
        <v-text-field
          variant="outlined"
          label="PASSWORD"
          v-model="inputPassword"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          name="input-10-1"
          @click:append="showPassword = !showPassword"
        ></v-text-field>
        <v-btn color="primary" @click="login" class="mb-2">Login</v-btn><br />
        {{ errorMsg }}
      </v-container>
      <v-container style="text-align: center" v-if="loginState == true">
        <v-list lines="one">
          <v-divider></v-divider>
          <v-list-item @click="$router.push('/')">TOP</v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="$router.push('/post')">投稿</v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="$router.push('/setting')">管理</v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="loginState = false">ログアウト</v-list-item>
          <v-divider></v-divider> </v-list
      ></v-container>
    </v-navigation-drawer>
    <v-main>
      <v-container>
        <router-view />
      </v-container>
    </v-main>
    <v-footer color="primary" app>©DreamVision Inc.</v-footer>
  </v-app>
</template>

<script>
//import DisplayPosts from "./components/DisplayPosts.vue";
import Export from "./export";
import store from "./store";
export default {
  name: "App",
  components: {
    //DisplayPosts,
  },
  data() {
    return {
      drawer: false,
      inputUser: "admin",
      inputPassword: "",
      user: "",
      password: "",
      errorMsg: "",
      showPassword: false,
    };
  },
  async mounted() {
    this.getUser();
  },
  computed: {
    loginState: {
      get() {
        return store.state.loginState;
      },
      set(value) {
        store.state.loginState = value;
      },
    },
    isLoading: {
      get() {
        return store.state.isLoading;
      },
      set(value) {
        store.state.isLoading = value;
      },
    },
  },
  methods: {
    showMenu() {
      console.log("touch");
    },
    async getUser() {
      var getUser = await Export.getUser();
      this.user = getUser.data[0].user;
      this.password = getUser.data[0].password;
    },
    login() {
      if (this.user == this.inputUser && this.password == this.inputPassword) {
        this.errorMsg = "";
        this.loginState = true;
        console.log("login");
      } else {
        this.errorMsg = "USERまたはPASSWORDが間違っています。";
      }
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.logo {
  height: 35px;
  width: auto;
}
.v-toolbar-title {
  line-height: 5% !important;
}
.v-footer {
  color: #fff !important;
  font-size: 12px;
}
#loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  z-index: 9999;
  position: fixed;
  background-color: rgba(#000, 0.5);
}
</style>
